// Parent product component
if (!customElements.get('component-pdp-bundle')) {
  customElements.define('component-pdp-bundle', class PDPBundle extends HTMLElement {
    constructor() {
      super();
      this.state = {
        expandedItemNumber: 1,
        activeBundleItem: '',
        activeBundleColor: '',
        addToBagItems: {},
        globalSize: '',
        showBundleError: false
      }
      this.props = {
        bundleNumber: parseInt(this.dataset.bundleNumber),
        comparePriceEnabled: this.dataset.comparePriceEnabled === 'true'
      };
      this.dom = {
        template: this.querySelector('template')
      }
    }
    async connectedCallback() {
      if (JSON.parse(this.querySelector('.js-data-bundle-product').textContent).product.title != null) {
        this.props.product = JSON.parse(this.querySelector('.js-data-bundle-product').textContent).product;
        // Show error if not all items in bundle are available/active
        if (this.props.product.bundle_items.length !== this.props.bundleNumber) {
          this.state.showBundleError = true;
        }
        window.scrollTo(0, 0);
        this.sendViewItemGTMData();
      }
      // Listen for state change from product subcomponents
      this.addEventListener('set-state', (event) => {
        let detail = {};
        if (event.detail) {
          if (event.detail.globalSize) {
            this.state.globalSize = event.detail.globalSize;
          }
          if (event.detail.activeBundleItem) {
            this.state.activeBundleItem = event.detail.activeBundleItem;
          }
          if (event.detail.activeBundleColor) {
            this.state.activeBundleColor = event.detail.activeBundleColor;
          }
          if (event.detail.expandedItemNumber) {
            this.state.expandedItemNumber = event.detail.expandedItemNumber;
          }
          if (event.detail.addToBagItem && event.detail.addToBagItemId) {
            this.state.addToBagItems[event.detail.addToBagItemId] = event.detail.addToBagItem;
          }
          if (event.detail.componentsToRender) {
            detail.componentsToRender = event.detail.componentsToRender;
          }
          this.dispatchEvent(new CustomEvent('render', { detail: detail }));
        }
      });
    }
    sendViewItemGTMData() {
      window.sendGTMData && window.sendGTMData({
        event: 'pdp_view_item',
        product_id: this.props.product.id
      });
    }
  });
}

// Boilerplate class used for all product subcomponents
class PDPBundleSubComponent extends HTMLElement {
  constructor() {
    super();
    this.props = {
      hydration: this.dataset.hydration && this.dataset.hydration === 'true' ? true : false
    }
    this.dom = {
      parentComponent: document.querySelector('component-pdp-bundle'),
      template: this.querySelector('.js-template')
    }
    if (this.props.hydration) {
      const template = document.createElement('template');
      template.content.appendChild(this.dom.template.cloneNode(true).querySelector('.js-container'));
      this.template = template;
    } else {
      this.template = this.dom.template;
    }
    this.dom.parentComponent.addEventListener('render', (event) => {
      // Render all components by default
      let componentsToRender = 'all';
      if (event.detail && event.detail.componentsToRender) {
        componentsToRender = event.detail.componentsToRender;
      }
      // Support ability to re-render only certain components using the component name
      const name = this.tagName.toLowerCase().replace(/-/g, '').replace(/component/g, '');
      const components = componentsToRender.toLowerCase();
      if (components === 'all' || components.includes(name)) {
        if (this.querySelector('.js-container')) {
          this.querySelector('.js-container').remove();
        }
        this.render();
      }
    });
  }
  appendTemplate(template) {
    // Remove ssr node before appending new template
    if (this.props.hydration && this.querySelector('.js-template')) this.querySelector('.js-template').remove();
    this.appendChild(template);
    this.afterRender();
  }
  getActiveColor() {
    if (this.dom.parentComponent.state.activeBundleItem && this.dom.parentComponent.state.activeBundleColor) {
      return this.dom.parentComponent.state.activeBundleItem.colors[this.dom.parentComponent.state.activeBundleColor];
    }
    return false;
  }
  getProduct() {
    return this.dom.parentComponent.props.product;
  }
  getId() {
    let productId = this.dom.parentComponent.props.product.id;
    if (this.getActiveColor()) {
      productId = this.getActiveColor().id;
    }
    return productId;
  }
  hasSameProduct() {
    return this.dom.parentComponent.props.product.bundle_items.every(item => item.title === this.dom.parentComponent.props.product.bundle_items[0].title);
  }
  hasSameType() {
    return this.dom.parentComponent.props.product.bundle_items.every(item => item.type === this.dom.parentComponent.props.product.bundle_items[0].type);
  }
  // Add 'pdp_hide_global_size' to parent bundle product to force sizing on bundle item level
  hasHideGlobalSizeTag() {
    return this.dom.parentComponent.props.product.tags.some(tag => tag === 'pdp_hide_global_size');
  }
  showGlobalSize() {
    if (this.hasSameType() && !this.hasHideGlobalSizeTag()) {
      return true;
    }
    return false;
  }
  hasBandCup() {
    return this.dom.parentComponent.props.product.bundle_items.some(item => item.type === 'Bra' && !item.tags.includes('alpha'));
  }
  hasAlpha() {
    return this.dom.parentComponent.props.product.bundle_items.some(item => (item.type === 'Bra' && item.tags.includes('alpha')) || item.type !== 'Bra');
  }
  getModelSize(id) {
    let size;
    if (this.dom.parentComponent.state.activeBundleItem.type === 'Bra') {
      if (window.theme.settings.multipleModels.models[id]) {
        size = window.theme.settings.multipleModels.models[id].braSize;
      }
    } else if (this.dom.parentComponent.state.activeBundleItem.type === 'Panties') {
      if (window.theme.settings.multipleModels.models[id]) {
        size = window.theme.settings.multipleModels.models[id].underwearSize;
      }
    }
    return size;
  }
  getSizes() {
    // Get all sizes across all bundle items
    const sizes = [];
    for (const bundleItem of this.dom.parentComponent.props.product.bundle_items) {
      for (const color in bundleItem.colors) {
        if (bundleItem.colors[color].sizes) {
          sizes.unshift(...bundleItem.colors[color].sizes);
        }
      }
    }
    return sizes;
  }
  updateSizeState(sizeOption) {
    if (sizeOption.dataset.name === 'band') this.state.bandSize = sizeOption.dataset.size;
    if (sizeOption.dataset.name === 'cup') this.state.cupSize = sizeOption.dataset.size;
    if (sizeOption.dataset.name === 'alpha') this.state.alphaSize = sizeOption.dataset.size;
    if (this.state.bandSize && this.state.cupSize) {
      this.state.selectedSize = `${this.state.bandSize}${this.state.cupSize}`;
    } else if (this.state.alphaSize) {
      this.state.selectedSize = sizeOption.dataset.size;
    }
    document.dispatchEvent(new CustomEvent('clear-add-to-bag-error'));
  }
  sendSizeChangeGTMData(size) {
    window.sendGTMData && window.sendGTMData({
      event: 'pdp_item_size_select',
      product_id: this.getId(),
      size_selected: size,
      source: 'pdp'
    });
  }
}

if (!customElements.get('component-pdp-bundle-gallery')) {
  customElements.define('component-pdp-bundle-gallery', class PDPBundleGallery extends PDPBundleSubComponent {
    constructor() {
      super();
      this.state = {
        expanded: false,
        numberImagesShown: null
      }
      this.props.badgePrefix = this.dataset.badgePrefix;
      document.addEventListener('update-images', (event) => {
        if (event && event.detail.images) {
          // Update state with new images
          if (this.querySelector('.js-container')) {
            this.querySelector('.js-container').remove();
          }
          this.render(event.detail.images);
          if (this.dataset.isLanding !== 'true') {
            window.scrollTo(0, 0);
          }
        }
      });
      this.render();
    }
    async render(modelImages) {
      const template = this.template.content.cloneNode(true);
      // Reset expanded state
      this.state.expanded = false;
      this.defaultImgSize = '300';
      this.renderGallery(template, modelImages);
      this.renderBadge(template);
      this.renderMobileGallery(template, modelImages);
      this.appendTemplate(template);
    }
    renderGallery(template, modelImages) {
      let images = this.getImages(modelImages);
      images = images.slice();
      let models = [];
      images.forEach((image, index) => {
        const imgTemplate = template.querySelector('.js-template-image').content.cloneNode(true);
        // Set responsive image
        imgTemplate.querySelector('.js-image').srcset = getSrcset(image.src, this.defaultImgSize);
        // Set data-src and update src after render (safari fix)
        imgTemplate.querySelector('.js-image').dataset.src = image.src;
        imgTemplate.querySelector('.js-image').sizes = '500px';
        imgTemplate.querySelector('.js-image').alt = image.alt;
        imgTemplate.querySelector('.js-image').width = image.width;
        imgTemplate.querySelector('.js-image').height = image.height;
        imgTemplate.querySelector('.js-image').dataset.index = index;
        imgTemplate.querySelector('.js-image').classList.add(`js-image-${index}`);
        if (index > 1) {
          imgTemplate.querySelector('.js-image').loading = "lazy";
        }
        // Set up models text
        const modelTemplate = imgTemplate.querySelector('.js-template-model-text').content.cloneNode(true);
        const alt = image.alt.trim().split('model')[1];
        // Skip first image
        if (alt && !models.includes(alt) && index != 0) {
          models.push(alt);
          let size = this.getModelSize(alt);
          if (size) {
            modelTemplate.querySelector('.js-size').innerHTML = size;
            imgTemplate.querySelector('.js-image-container').appendChild(modelTemplate);
          }
        }
        template.querySelector('.js-gallery').appendChild(imgTemplate);
      });
      // Set state for zoom feature
      this.state.images = images;
      // Handle grid gradient / see more photos
      if (images.length > 8) {
        this.state.numberImagesShown = 6;
      } else if (images > 6) {
        this.state.numberImagesShown = 4;
      } else {
        this.state.numberImagesShown = null;
      }
      if (this.state.numberImagesShown) {
        template.querySelector('.js-gallery').classList.add(`gallery-${this.state.numberImagesShown}`);
        const gradientTemplate = template.querySelector('.js-template-gallery-gradient').content.cloneNode(true);
        gradientTemplate.querySelector('.js-gradient').classList.add(`gallery-gradient-${this.state.numberImagesShown}`);
        template.querySelector('.js-gallery-container').appendChild(gradientTemplate);
        const moreBtnTemplate = template.querySelector('.js-template-more-btn').content.cloneNode(true);
        template.querySelector('.js-container').appendChild(moreBtnTemplate.querySelector('div'));
      }
    }
    renderBadge(template) {
      // Add badge to gallery
      if (template.querySelector('.js-template-gallery-badge')) {
        let tags;
        if (this.dom.parentComponent.props.product.tags.length > 0 && this.dom.parentComponent.props.product.tags.find(tag => tag.includes(this.props.badgePrefix))) {
          tags = this.dom.parentComponent.props.product.tags;
        } else if (this.getActiveColor() && this.getActiveColor().tags && this.getActiveColor().tags.find(tag => tag.includes(this.props.badgePrefix))) {
          tags = this.getActiveColor().tags;
        }
        if (tags) {
          let badge;
          for (let tag in tags) {
            if (typeof tags[tag] === 'string' && tags[tag].includes(this.props.badgePrefix)) {
              badge = tags[tag].replace(this.props.badgePrefix, '');
              break;
            }
          }
          if (badge) {
            const badgeTemplate = template.querySelector('.js-template-gallery-badge').content.cloneNode(true);
            badgeTemplate.querySelector('.js-gallery-badge').innerHTML = badge;
            template.querySelector('.js-gallery-container').append(badgeTemplate);
          }
        }
      }
    }
    renderMobileGallery(template, modelImages) {
      let mobileImages = this.getImages(modelImages);
      mobileImages = mobileImages.slice();
      mobileImages.forEach((image, index) => {
        const mobileImgTemplate = template.querySelector('.js-template-mobile-image').content.cloneNode(true);
        // Set responsive image
        mobileImgTemplate.querySelector('.js-mobile-image').srcset = getSrcset(image.src, this.defaultImgSize);
        // Set data-src and update src after render (safari fix)
        mobileImgTemplate.querySelector('.js-mobile-image').dataset.src = image.src;
        mobileImgTemplate.querySelector('.js-mobile-image').sizes = '300px';
        mobileImgTemplate.querySelector('.js-mobile-image').alt = image.alt;
        mobileImgTemplate.querySelector('.js-mobile-image').width = image.width;
        mobileImgTemplate.querySelector('.js-mobile-image').height = image.height;
        mobileImgTemplate.querySelector('.js-mobile-image').dataset.index = index;
        if (index > 1) {
          mobileImgTemplate.querySelector('.js-mobile-image').loading = 'lazy';
        }
        mobileImgTemplate.querySelector('.js-mobile-image').classList.add(`js-mobile-image-${index}`);
        template.querySelector('.js-gallery-mobile').appendChild(mobileImgTemplate);
        // Mobile dots
        const mobileDotTemplate = template.querySelector('.js-template-gallery-mobile-dot').content.cloneNode(true);
        mobileDotTemplate.querySelector('.js-dot').classList.add(`js-dot-${index}`);
        mobileDotTemplate.querySelector('.js-dot').dataset.index = index;
        template.querySelector('.js-gallery-mobile-dots').appendChild(mobileDotTemplate);
      });
    }
    getImages(modelImages) {
      let images = [];
      if (modelImages) {
        images = modelImages;
      } else if (this.getActiveColor()) {
        images = this.getActiveColor().images;
      } else {
        images = this.getProduct().images;
      }
      return images;
    }
    handleMobileGallery() {
      // Use intersection observer to set up navigation dots on mobile gallery
      let options = {
        root: this.querySelector('.js-gallery-mobile'),
        rootMargin: "0px",
        threshold: 0.4
      };
      let callback = (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.querySelectorAll('.js-dot').forEach(dot => {
              dot.classList.remove('active');
            });
            this.querySelector(`.js-dot-${entry.target.dataset.index}`).classList.add('active');
            const alt = entry.target.alt.trim().split('model')[1];
            if (alt) {
              document.dispatchEvent(new CustomEvent('update-model-size', {
                detail: {
                  modelSize: this.getModelSize(alt)
                }
              }));
            }
          }
        });
      };
      let observer = new IntersectionObserver(callback, options);
      this.querySelectorAll('.js-mobile-image').forEach(img => {
        observer.observe(img);
      });
      this.querySelectorAll('.js-dot').forEach(dot => {
        dot.addEventListener('click', () => {
          const index = dot.dataset.index;
          this.querySelector(`.js-mobile-image-${index}`).scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        })
      });
    }
    renderZoomGallery(img) {
      const template = this.querySelector('.js-template-gallery-zoom').content.cloneNode(true);
      for (let imgData of this.state.images) {
        // Add thumbnails
        const thumbTemplate = template.querySelector('.js-template-zoom-thumb').content.cloneNode(true);
        const thumbImg = thumbTemplate.querySelector('.js-zoom-thumb');
        thumbImg.src = imgData.src;
        template.querySelector('.js-zoom-thumbs-container').appendChild(thumbTemplate);
      }
      // Add main image
      const imgTemplate = template.querySelector('.js-template-zoom-image').content.cloneNode(true);
      const zoomImg = imgTemplate.querySelector('.js-zoom-img');
      // Set main image to clicked image
      zoomImg.srcset = getSrcset(img.src, this.defaultImgSize);
      // Set data-src and update src after render (safari fix)
      zoomImg.dataset.src = img.src;
      template.querySelector('.js-zoom-img-container').appendChild(imgTemplate);
      this.querySelector('.js-gallery-container').appendChild(template);
      this.querySelector('.js-gallery-zoom-container').classList.remove('hidden');
      document.querySelector('body').classList.add('overflow-hidden');
      this.querySelector('.js-zoom-img').onload = () => {
        this.querySelector('.js-zoom-img').classList.add('loaded');
      }
    }
    afterRender() {
      this.setImageSrc();
      this.querySelectorAll('.js-image').forEach(img => {
        img.onload = () => img.classList.add('image--loaded');
      });
      this.querySelectorAll('.js-mobile-image').forEach(img => {
        img.onload = () => {
          img.classList.add('image--loaded');
          if (img.classList.contains('js-mobile-image-0')) {
            this.setMinHeight();
          }
        }
      });
      window.addEventListener('resize', () => {
        this.setMinHeight();
      });
      this.handleSeeMore();
      this.handleMobileGallery();
      this.handleZoomGallery(this.querySelectorAll('.js-image'));
    }
    handleZoomGallery(images) {
      images.forEach(img => {
        img.addEventListener('click', () => {
          this.renderZoomGallery(img);
          this.setImageSrc();
          this.querySelectorAll('.js-zoom-thumb').forEach(thumb => {
            thumb.addEventListener('click', () => {
              this.querySelector('.js-zoom-img').srcset = getSrcset(thumb.src, this.defaultImgSize);
              this.querySelector('.js-zoom-img').src = img.src;
            });
            thumb.addEventListener('mouseover', () => {
              this.querySelector('.js-zoom-img').srcset = getSrcset(thumb.src, this.defaultImgSize);
              this.querySelector('.js-zoom-img').src = thumb.src;
            });
          });
          this.querySelector('.js-zoom-close').addEventListener('click', () => {
            this.closeZoom();
          });
          this.querySelector('.js-zoom-img-container').addEventListener('click', (event) => {
            if (!event.target.classList.contains('js-zoom-img')) {
              this.closeZoom();
            }
          })
        });
      });
    }
    handleSeeMore() {
      if (this.state.numberImagesShown && this.querySelector('.js-gallery-more-btn')) {
        const collapsedText = this.querySelector('.js-gallery-more-btn-text').innerHTML;
        this.querySelector('.js-gallery-more-btn').addEventListener('click', () => {
          this.state.expanded = !this.state.expanded;
          this.querySelector('.js-gallery').classList.toggle(`gallery-${this.state.numberImagesShown}`);
          let text = this.state.expanded ? this.querySelector('.js-gallery-more-btn').dataset.expandedText : collapsedText;
          this.querySelector('.js-gallery-more-btn-text').innerHTML = text;
          this.querySelector('.js-gallery-more-btn-container').classList.toggle('gallery-more-btn-container--expanded');
          this.querySelector('.js-gallery-more-svg').classList.toggle('expanded');
          this.querySelector('.js-gradient').classList.toggle('gallery-gradient');
          if (!this.state.expanded) {
            window.scrollTo(0, 0);
          }
          this.sendSeeMorePhotosGTMData();
        });
      }
    }
    closeZoom() {
      this.querySelector('.js-gallery-zoom-container').classList.add('hidden');
      document.querySelector('body').classList.remove('overflow-hidden');
      this.querySelector('.js-gallery-zoom-container').remove();
    }
    setMinHeight() {
      if (this.querySelector('.js-mobile-image-0')) {
        const minHeight = this.querySelector('.js-mobile-image-0').clientHeight;
        this.dom.parentComponent.querySelector('.js-product-gallery-container').style.setProperty('--min-height', `${minHeight}px`);
      }
    }
    setImageSrc() {
      // Fixes a srcset bug across all Safari versions (desktop and mobile)
      const images = this.querySelectorAll('img[data-src]');
      if (images.length) {
        images.forEach(img => {
          if (!img.className.includes('lazyload')) {
            img.src = img.dataset.src;
          }
        });
      }
    }
    sendSeeMorePhotosGTMData() {
      window.sendGTMData && window.sendGTMData({
        event: 'pdp_see_more_photos',
        product_id: this.getId(),
        expanded: this.state.expanded,
        source: 'pdp-bundle'
      });
    }
  });
}

// Product info subcomponent
if (!customElements.get('component-pdp-bundle-info')) {
  customElements.define('component-pdp-bundle-info', class PDPBundleInfo extends PDPBundleSubComponent {
    constructor() {
      super();
      this.props.showPriceBadge = this.dataset.showPriceBadge;
      this.props.priceBadgeSetsTag = this.dataset.priceBadgeSetsTag;
    }
    async connectedCallback() {
      this.render();
    }
    render() {
      const template = this.template.content.cloneNode(true);

      // Set title and reviews
      if (this.getProduct()) {
        template.querySelector('.js-title').innerHTML = this.getProduct().style || this.getProduct().title.replace('®', '<sup>®</sup>');
        let reviewsProduct = this.getProduct();
        if (this.dom.parentComponent.props.product.bundle_items[0]) {
          reviewsProduct = this.dom.parentComponent.props.product.bundle_items[0];
        }
        if (this.dom.parentComponent.state.activeBundleItem) {
          reviewsProduct = this.dom.parentComponent.state.activeBundleItem;
        }
        if (this.getActiveColor()) {
          reviewsProduct = this.getActiveColor();
        }
        const reviewStars = `<component-review-stars data-reviews='${reviewsProduct.reviews_average}' data-total="${reviewsProduct.reviews_count}" data-type="product"></component-review-stars>`;
        template.querySelector('.js-review-stars').innerHTML = reviewStars;
      }

      // Set pricing
      const price = +this.getProduct().price;
      const comparePriceFromProduct = +this.getProduct()?.compare_at_price;
      template.querySelector('.js-price').innerHTML = toMoney(price);
      const selectedItems = Object.values(this.dom.parentComponent.state.addToBagItems).filter(item => item.id && item.price);
      const bundleItems = this.getProduct().bundle_items;
      if (selectedItems.length === bundleItems.length) {
        const comparePriceFromItemsInBag = selectedItems.reduce((acc, item) => {
          return acc + +item.price;
        }, 0);
        const compareAtPrice = comparePriceFromItemsInBag || comparePriceFromProduct;
        if (compareAtPrice > price) {
          template.querySelector('.js-compare-price').innerHTML = toMoney(compareAtPrice);
        } else {
          template.querySelector('.js-compare-price').classList.add('hidden');
          template.querySelector('.js-price').textContent = toMoney(compareAtPrice);
        }
      }
      this.renderPriceBadge(template, comparePriceFromProduct, price);

      // Afterpay
      if (template.querySelector('.js-afterpay')) {
        if (price > parseFloat(template.querySelector('.js-afterpay').dataset.minPrice)) {
          template.querySelector('.js-afterpay-price').innerHTML = toMoney(price / parseInt(template.querySelector('.js-afterpay-available').dataset.installments));
          template.querySelector('.js-afterpay-available').classList.remove('hidden');
          template.querySelector('.js-afterpay-unavailable').classList.add('hidden');
        } else {
          template.querySelector('.js-afterpay-available').classList.add('hidden');
          template.querySelector('.js-afterpay-unavailable').classList.remove('hidden');
        }
      }
      if (this.props.hydration && this.querySelector('.js-template')) this.querySelector('.js-template').remove();
      this.appendChild(template);
      this.afterRender();
    }
    renderPriceBadge(template, comparePrice, price) {
      if (this.props.showPriceBadge != 'none' && template.querySelector('.js-template-price-badge')) {
        const priceBadgeTemplate = template.querySelector('.js-template-price-badge').content.cloneNode(true);
        if (comparePrice > price) {
          priceBadgeTemplate.querySelectorAll('.js-price-badge-percent').forEach(percent => percent.innerHTML = `${Math.floor((1 - (price / comparePrice)) * 100)}%`);
          if (this.props.showPriceBadge === 'all' || (this.props.showPriceBadge === 'sets_only' && this.getSiblingColor().tags.includes(this.props.priceBadgeSetsTag))) {
            if(this.querySelector('.js-pdp-price-right-hand-side')) {
              template.querySelector('.js-pdp-price-right-hand-side .js-review-stars').after( priceBadgeTemplate);
            } else {
              template.querySelector('.js-price-container').appendChild(priceBadgeTemplate);
            }
          }
        }
      }
    }
    afterRender() {
      this.querySelector('.js-review-stars').addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('scroll-to-reviews'));
        if (document.querySelector('.js-product-reviews-desktop')) {
          document.querySelector('.js-product-reviews-desktop').scrollIntoView();
        }
      });
      this.handleAfterpay();
    }
    handleAfterpay() {
      if (this.querySelector('.js-afterpay-logo')) {
        this.querySelectorAll('.js-afterpay-logo').forEach(afterpayLogo => {
          afterpayLogo.addEventListener('click', () => {
            this.querySelector('#modal-afterpay').ariaHidden = false;
            this.querySelector('#modal-afterpay').classList.add('d-block');
          });
        });
      }
      if (this.querySelector('.js-afterpay-close')) {
        this.querySelector('.js-afterpay-close').addEventListener('click', () => {
          this.querySelector('#modal-afterpay').ariaHidden = true;
          this.querySelector('#modal-afterpay').classList.remove('d-block');
        });
        this.querySelector('.modal__overlay').addEventListener('click', event => {
          const isClickInside = this.querySelector('.js-modal-container').contains(event.target)
          if (!isClickInside) {
            this.querySelector('#modal-afterpay').ariaHidden = true;
            this.querySelector('#modal-afterpay').classList.remove('d-block');
          }
        })
      }
    }
  });
}

// Product size subcomponent
if (!customElements.get('component-pdp-bundle-size')) {
  customElements.define('component-pdp-bundle-size', class PDPBundleSize extends PDPBundleSubComponent {
    constructor() {
      super();
      this.state = {
        bandSize: '',
        cupSize: '',
        alphaSize: '',
        selectedSize: ''
      };
      if (this.dom.parentComponent.props.product.bundle_items) {
        this.render();
      }
    }
    render() {
      const template = this.template.content.cloneNode(true);
      // Show size buttons that apply to all bundle products
      if (this.showGlobalSize()) {
        if (this.hasBandCup() && !this.hasAlpha()) {
          this.renderSizes(template, "band", 0, 2);
          this.renderSizes(template, "cup", 2, undefined);
        } else if (!this.hasBandCup() && this.hasAlpha()) {
          this.renderSizes(template, "alpha", 0, undefined);
        }
      }
      this.renderSizeChart(template);
      this.appendTemplate(template);
    }
    renderSizes(template, name, subStart, subEnd) {
      const sizeTemplate = template.querySelector('.js-template-size').content.cloneNode(true);
      sizeTemplate.querySelector('.js-size-buttons').classList.add(`js-${name}-buttons`);
      sizeTemplate.querySelector('.js-size-label').innerHTML = `${name !== 'alpha' ? name : ''} Size`;
      let sizes = this.getSizes();
      if (name === 'cup' && this.state.bandSize) {
        sizes = sizes.filter(size => size.substring(0, 2) === this.state.bandSize);
      }
      sizes = sizes.map(size => size.substring(subStart, subEnd));
      // Get unique values
      sizes = [...new Set(sizes)];
      // Sort ascending order for bands and cups
      if (name !== 'alpha') {
        sizes.sort();
        sizes.sort((a) => {
          if (a === 'AA') {
            return -1;
          }
          return 0;
        });
      }
      for (let size of sizes) {
        let label = size;
        if (size === 'E') label += ' (DD)';
        if (size === 'E½') label += ' (DD½)';
        if (size === 'E-E½') label += ' (DD-DD½)';
        if (size === 'F') label += ' (DDD)';
        if (size === 'G') label += ' (DDDD)';
        if (size === 'H') label += ' (DDDDD)';
        if (size === 'I') label += ' (DDDDDD)';
        const optionTemplate = sizeTemplate.querySelector('.js-template-size-option').content.cloneNode(true);
        optionTemplate.querySelector('.js-size-option-value').innerHTML = label;
        optionTemplate.querySelector('.js-size-option-value').dataset.size = size;
        optionTemplate.querySelector('.js-size-option-value').dataset.name = name;
        const uniqueId = `${name}-input-${size}`;
        optionTemplate.querySelector('.js-input').id = uniqueId;
        optionTemplate.querySelector('.js-input').name = `${name}-input`;
        optionTemplate.querySelector('.js-input').dataset.size = size;
        optionTemplate.querySelector('.js-size-option-value').htmlFor = uniqueId;
        // Set active size from state
        let populateSize = false;
        if (name === 'band' && size === this.state.bandSize) {
          populateSize = true;
        } else if (name === 'cup' && size === this.state.cupSize) {
          populateSize = true;
        } else if (name === 'alpha' && size === this.state.alphaSize) {
          populateSize = true;
        }
        if (populateSize) {
          optionTemplate.querySelector('.js-input').checked = true;
          optionTemplate.querySelector('.js-input').classList.add('checked');
        }
        // Add option to options list
        sizeTemplate.querySelector('.js-size-options').appendChild(optionTemplate);
      }
      template.querySelector('.js-sizes').appendChild(sizeTemplate);
    }
    renderSizeChart(template) {
      let types = [];
      this.dom.parentComponent.props.product.bundle_items.forEach(item => {
        const chartType = getSizeChartType(item.type.toLowerCase(), item.title.toLowerCase(), item.vendor.toLowerCase(), item.tags);
        if (chartType) {
          types.push(chartType);
        }
      });
      // Get unique values
      types = [...new Set(types)];
      const showMultipleCharts = types.length > 1 ? true : false;
      if (showMultipleCharts) {
        const sizeChartTextTemplate = template.querySelector('.js-template-size-chart-label').content.cloneNode(true);
        template.querySelector('.js-size-chart').appendChild(sizeChartTextTemplate);
      }
      for (let type of types) {
        const sizeChartTemplate = template.querySelector('.js-template-size-chart').content.cloneNode(true);
        sizeChartTemplate.querySelector('component-product-size-chart').dataset.sizeChartType = type;
        sizeChartTemplate.querySelector('component-product-size-chart').dataset.showMultipleCharts = showMultipleCharts;
        sizeChartTemplate.querySelector('component-product-size-chart').dataset.id = this.getProduct().id;
        if (types.length === 1 && this.showGlobalSize()) {
          template.querySelector('.js-size-chart-in-line').appendChild(sizeChartTemplate);
        } else {
          template.querySelector('.js-size-chart').classList.add('divider-bottom');
          template.querySelector('.js-size-chart').appendChild(sizeChartTemplate);
        }
      }
    }
    afterRender() {
      if (document.querySelector('.js-variants-accordions-container')) {
        document.querySelector('.js-variants-accordions-container').classList.remove('hidden');
      }
      this.handleSizeChange();
    }
    handleSizeChange() {
      this.querySelectorAll('.js-size-buttons').forEach(group => {
        group.querySelectorAll('.js-size-option-value').forEach(sizeOption => {
          sizeOption.addEventListener('click', () => {
            this.updateSizeState(sizeOption);
            // Update parent state
            this.dispatchEvent(new CustomEvent('set-state', {
              bubbles: true,
              detail: {
                componentsToRender: 'PDPBundleItem',
                globalSize: this.state.selectedSize
              }
            }));
            this.sendSizeChangeGTMData(this.state.selectedSize);
          });
        });
      });
    }
  });
}

if (!customElements.get('component-pdp-bundle-item')) {
  customElements.define('component-pdp-bundle-item', class PDPBundleItem extends PDPBundleSubComponent {
    constructor() {
      super();
      this.state = {
        expanded: false,
        bandSize: '',
        cupSize: '',
        alphaSize: '',
        bundleItem: {},
        selectedColor: '',
        selectedSize: '',
        selectedStyleHandle: '',
        updateState: false
      }
      this.props.id = parseInt(this.dataset.id);
      this.props.itemNumber = parseInt(this.dataset.itemNumber);
      this.props.featuredImage = this.dataset.featuredImage;
      this.props.inventoryQuantityThreshold = parseInt(this.dataset.inventoryQuantityThreshold);
      this.props.inventoryQuantityMessage = this.dataset.inventoryQuantityMessage;
      this.props.sizeColorError = this.dataset.sizeColorError;
      this.props.sizeError = this.dataset.sizeError;
      this.props.colorError = this.dataset.colorError;
    }
    async connectedCallback() {
      this.state.bundleItem = this.dom.parentComponent.props.product.bundle_items.find(item => item.id === this.props.id);
      this.props.styles = this.state.bundleItem.styles;
      // Keep first two items expanded by default so both option blocks are visible.
      if (this.props.itemNumber) {
        this.state.expanded = true;
      }
      if (this.dom.parentComponent.props.product.tags.find(item => item === 'pdp_expand_all')) {
        this.state.expanded = true;
      }
      this.render();
      document.addEventListener('add-to-bag-error', () => {
        const item = this.dom.parentComponent.state.addToBagItems[this.props.itemNumber];
        if (!item || Object.keys(item).length === 0) {
          this.expand(this, true);
          if (!this.state.selectedColor && !this.state.selectedSize) {
            this.querySelector('.js-error').textContent = this.props.sizeColorError;
          } else if (!this.state.selectedSize) {
            this.querySelector('.js-error').textContent = this.props.sizeError;
          } else if (!this.state.selectedColor) {
            this.querySelector('.js-error').textContent = this.props.colorError;
          }
          this.querySelector('.js-error').classList.remove('hidden');
        }
      });
    }
    render() {
      const template = this.template.content.cloneNode(true);
      if (!this.state.expanded) {
        this.state.expanded = this.props.itemNumber === this.dom.parentComponent.state.expandedItemNumber;
      }
      this.initState();
      this.renderTitle(template);
      if (!this.showGlobalSize()) {
        // Render size dropdowns per bundle item
        if (this.itemHasBandCup() && !this.itemHasAlpha()) {
          this.renderSizeDropdown(template, "band", 0, 2);
          this.renderSizeDropdown(template, "cup", 2, undefined);
        } else if (!this.itemHasBandCup() && this.itemHasAlpha()) {
          this.renderSizeDropdown(template, "alpha", 0, undefined);
        }
        this.renderCollapsedText(template, "size");
      }
      this.renderStyles(template);
      this.renderColors(template);
      this.renderCollapsedText(template, "color");
      this.renderImage(template);
      this.renderOutOfStock(template);
      this.renderFinalSaleMessage(template);
      if (this.props.inventoryQuantityThreshold !== 0) {
        this.renderInventoryMessage(template, this.isOutOfStock());
      }
      this.expand(template);
      this.appendTemplate(template);
    }
    initState() {
      this.state.updateState = false;
      // Default to first color if style changed and selected color doesn't exist
      if (this.state.selectedColor && !this.state.bundleItem.colors[this.state.selectedColor]) {
        this.state.selectedColor = this.state.bundleItem.color;
      }
      // Default to color if only 1 color exists
      if (!this.state.selectedColor && Object.keys(this.state.bundleItem.colors).length === 1) {
        this.state.selectedColor = this.state.bundleItem.color;
      }
      if (this.showGlobalSize() && this.dom.parentComponent.state.globalSize) {
        // If global size changes, update state
        if (this.state.selectedSize !== this.dom.parentComponent.state.globalSize) {
          this.state.selectedSize = this.dom.parentComponent.state.globalSize;
          if (this.itemHasBandCup() && !this.itemHasAlpha()) {
            this.state.bandSize = this.state.selectedSize.substring(0, 2);
            this.state.cupSize = this.state.selectedSize.substring(2);
          } else if (!this.itemHasBandCup() && this.itemHasAlpha()) {
            this.state.alphaSize = this.state.selectedSize;
          }
          // Since local size state updated, will need to update parent state with new bundle item variant id
          this.state.updateState = true;
        }
      }
    }
    renderTitle(template) {
      template.querySelectorAll('.js-bundle-item-title').forEach(title => {
        title.innerHTML = this.state.bundleItem.title;
      });
    }
    renderSizeDropdown(template, name, subStart, subEnd) {
      const sizeDropdownTemplate = template.querySelector('.js-template-size-dropdown').content.cloneNode(true);
      sizeDropdownTemplate.querySelector('.js-size-label').innerHTML = `${name !== 'alpha' ? name : ''} Size`;
      let sizes = this.getItemSizes();
      if (this.state.selectedColor) {
        sizes = Object.keys(this.state.bundleItem.colors[this.state.selectedColor].variants);
      }
      if (name === 'cup' && this.state.bandSize) {
        sizes = sizes.filter(size => size.substring(0, 2) === this.state.bandSize);
      }
      sizes = sizes.map(size => size.substring(subStart, subEnd));
      // Get unique values
      sizes = [...new Set(sizes)];
      // Sort ascending order for bands and cups
      if (name !== 'alpha') {
        sizes.sort();
        sizes.sort((a) => {
          if (a === 'AA') {
            return -1;
          }
          return 0;
        });
      }
      for (let size of sizes) {
        let label = size;
        if (size === 'E') label += ' (DD)';
        if (size === 'E½') label += ' (DD½)';
        if (size === 'E-E½') label += ' (DD-DD½)';
        if (size === 'F') label += ' (DDD)';
        if (size === 'G') label += ' (DDDD)';
        if (size === 'H') label += ' (DDDDD)';
        if (size === 'I') label += ' (DDDDDD)';
        const option = document.createElement('option');
        option.innerHTML = label;
        option.dataset.size = size;
        option.dataset.name = name;
        const uniqueId = `${name}-input-${size}`;
        option.id = uniqueId;
        // Add option to options list
        sizeDropdownTemplate.querySelector('.js-size-dropdown').appendChild(option);
        // Set active size from state
        let populateSize = false;
        if (name === 'band' && size === this.state.bandSize) {
          populateSize = true;
        } else if (name === 'cup' && size === this.state.cupSize) {
          populateSize = true;
        } else if (name === 'alpha' && size === this.state.alphaSize) {
          populateSize = true;
        }
        if (populateSize) {
          option.selected = true;
        }
      }
      template.querySelector('.js-sizes-container').appendChild(sizeDropdownTemplate);
    }
    renderStyles(template) {
      if (this.props.styles) {
        const stylesTemplate = template.querySelector('.js-template-styles-dropdown').content.cloneNode(true);
        for (const styleName of Object.keys(this.props.styles)) {
          const option = document.createElement('option');
          const handle = this.props.styles[styleName];
          option.value = handle;
          option.innerHTML = styleName;
          if (handle === this.state.selectedStyleHandle) {
            option.selected = true;
          }
          stylesTemplate.querySelector('.js-styles-dropdown').appendChild(option);
        }
        template.querySelector('.js-styles-container').appendChild(stylesTemplate);
      }
    }
    renderColors(template) {
      const colors = Object.values(this.state.bundleItem.colors);
      for (const color of colors) {
        this.addColor(color.color, color.id, template);
      }
    }
    addColor(color, id, template) {
      const colorTemplate = template.querySelector('.js-template-color').content.cloneNode(true);
      if (window.theme.colors[color]) {
        // Set CSS custom properties for swatch styling
        if (window.theme.colors[color].image) {
          colorTemplate.querySelector('.js-label').style.setProperty('--swatch-image', `url(${window.theme.colors[color].image}`);
        }
        colorTemplate.querySelector('.js-label').style.setProperty('--swatch-color', window.theme.colors[color].color);
        colorTemplate.querySelector('.js-label').style.setProperty('--swatch-border-color', '#fff');
      }
      colorTemplate.querySelector('.js-label').setAttribute('for', `color_${color}_${this.state.bundleItem.id}_${this.props.itemNumber}`)
      colorTemplate.querySelector('.js-input').value = color;
      colorTemplate.querySelector('.js-input').id = `color_${color}_${this.state.bundleItem.id}_${this.props.itemNumber}`;
      colorTemplate.querySelector('.js-input').name = `color_${this.state.bundleItem.id}_${this.props.itemNumber}`;
      if (this.state.selectedColor === color) {
        colorTemplate.querySelector('.js-input').checked = true;
        if (window.theme.colors[color]) {
          template.querySelector(`.js-active-color`).textContent = window.theme.colors[color].title;
        }
      }
      // Handle colors that are out of stock for selected size
      let availableSizes = this.state.bundleItem.colors[color].availableSizes;
      if (this.hasBandCup() && (this.state.bandSize || this.state.cupSize)) {
        // Filter by band size
        if (this.state.bandSize) availableSizes = availableSizes.filter(size => size.substring(0, 2) === this.state.bandSize)
        if (this.state.cupSize) {
          if (this.state.cupSize.includes('-') || availableSizes.some(size => size.includes('-'))) {
            // Handle cases where product cup size includes half size (ex: "C-C½", Kinetic Impact Sports Bra)
            availableSizes = availableSizes.filter(size => size.substring(2).includes(this.state.cupSize) || this.state.cupSize.includes(size.substring(2)));
          } else {
            availableSizes = availableSizes.filter(size => size.substring(2) === this.state.cupSize)
          }
        }
      } else {
        // Handle Alpha
        if (this.state.alphaSize) {
          availableSizes = availableSizes.filter(size => size === this.state.alphaSize);
        }
      }
      colorTemplate.querySelector('.js-name').innerHTML = color;
      if (availableSizes.length < 1) {
        colorTemplate.querySelector('.js-label').classList.add('color-label--out-of-stock')
      }
      template.querySelector('.js-colors').appendChild(colorTemplate);
    }
    renderOutOfStock(template) {
      if (this.isOutOfStock()) {
        template.querySelector('.js-out-of-stock').classList.remove('hidden')
      } else {
        template.querySelector('.js-out-of-stock').classList.add('hidden');
      }
    }
    renderFinalSaleMessage(template) {
      if (!this.isOutOfStock() && this.getItemColor() && isFinalSale(this.getItemColor().tags)) {
        template.querySelector('.js-final-sale').classList.remove('hidden');
      } else {
        template.querySelector('.js-final-sale').classList.add('hidden');
      }
    }
    renderInventoryMessage(template, isOutOfStock) {
      if (this.getVariant() && !isOutOfStock && this.getVariant().inventory_management === 'shopify' && this.getVariant().inventory_policy === 'deny' && Number(this.getVariant().inventory_quantity) < this.props.inventoryQuantityThreshold) {
        template.querySelector('.js-inventory-message').textContent = this.props.inventoryQuantityMessage.replace('#', this.getVariant().inventory_quantity);
        template.querySelector('.js-inventory-message').classList.remove('hidden');
      } else {
        template.querySelector('.js-inventory-message').classList.add('hidden');
      }
    }
    renderImage(template) {
      let imageSrc = this.props.featuredImage;
      if (this.state.bundleItem.colors[this.state.selectedColor]) {
        imageSrc = this.state.bundleItem.colors[this.state.selectedColor].images[0].src;
      }
      template.querySelector('.js-bundle-item-image').src = imageSrc;
    }
    renderCollapsedText(template, type) {
      const collapsedTextTemplate = template.querySelector('.js-template-bundle-collapsed-text').content.cloneNode(true);
      if (type === 'size') {
        if (this.state.selectedSize) {
          collapsedTextTemplate.querySelector('.js-bundle-collapsed-text').innerHTML = 'SIZE';
          collapsedTextTemplate.querySelector('.js-bundle-collapsed-text').classList.add('bundle-item-collapsed-text--selected')
          collapsedTextTemplate.querySelector('.js-bundle-collapsed-selection').innerHTML = this.state.selectedSize;
        } else {
          collapsedTextTemplate.querySelector('.js-bundle-collapsed-text').innerHTML = 'Select Size';
        }
      } else if (type === 'color') {
        if (this.state.selectedColor) {
          collapsedTextTemplate.querySelector('.js-bundle-collapsed-text').innerHTML = 'COLOR';
          collapsedTextTemplate.querySelector('.js-bundle-collapsed-text').classList.add('bundle-item-collapsed-text--selected')
          if (window.theme.colors[this.state.selectedColor]) {
            collapsedTextTemplate.querySelector('.js-bundle-collapsed-selection').innerHTML = window.theme.colors[this.state.selectedColor].title;
          }
        } else {
          collapsedTextTemplate.querySelector('.js-bundle-collapsed-text').innerHTML = 'Select Color';
          collapsedTextTemplate.querySelector('.js-bundle-collapsed-text-type').classList.add('js-bundle-collapsed-text-type--color');
        }
      }
      template.querySelector('.js-bundle-collapsed-text-container').appendChild(collapsedTextTemplate);
    }
    expand(template, expand = false) {
      if (this.state.expanded || expand) {
        template.querySelector('.js-expanded').classList.remove('hidden');
        template.querySelector('.js-collapsed').classList.add('hidden');
        template.querySelector('.js-expand-arrow').classList.add('bundle-item--expanded');
      } else {
        template.querySelector('.js-expanded').classList.add('hidden');
        template.querySelector('.js-collapsed').classList.remove('hidden');
        template.querySelector('.js-expand-arrow').classList.remove('bundle-item--expanded');
      }
    }
    // Helpers
    itemHasBandCup() {
      return this.state.bundleItem.type === 'Bra' && !this.state.bundleItem.tags.includes('alpha');
    }
    itemHasAlpha() {
      return (this.state.bundleItem.type === 'Bra' && this.state.bundleItem.tags.includes('alpha')) || this.state.bundleItem.type !== 'Bra';
    }
    getItemColor() {
      if (this.state.bundleItem && this.state.selectedColor) {
        return this.state.bundleItem.colors[this.state.selectedColor];
      }
      return false;
    }
    isOutOfStock() {
      return this.state.selectedSize && this.getItemColor() && this.getItemColor().availableSizes.indexOf(this.state.selectedSize) === -1;
    }
    getItemSizes() {
      const availableSizes = [];
      for (const color in this.state.bundleItem.colors) {
        if (this.state.bundleItem.colors[color].sizes) {
          availableSizes.push(...this.state.bundleItem.colors[color].sizes);
        }
      }
      return availableSizes;
    }
    getVariant() {
      if (this.getItemColor() && this.state.selectedSize && this.getItemColor().variants[this.state.selectedSize]) {
        return this.getItemColor().variants[this.state.selectedSize];
      }
      return false;
    }
    afterRender() {
      this.handleExpand();
      this.handleSizeChange();
      this.handleColorChange();
      this.handleStyleChange();
      if (this.state.updateState) {
        this.setState('none', false);
      }
    }
    handleExpand() {
      this.querySelectorAll('.js-expand').forEach(btn => {
        btn.addEventListener('click', event => {
          event.preventDefault();
          this.state.expanded = !this.state.expanded;
          this.expand(this);
        });
      });
    }
    handleSizeChange() {
      const dropdowns = this.querySelectorAll('.js-size-dropdown');
      dropdowns.forEach(dropdown => {
        dropdown.addEventListener('change', sizeOption => {
          const selectedOption = dropdown.options[sizeOption.target.selectedIndex];
          this.updateSizeState(selectedOption);
          this.setState('PDPBundleItem');
          this.sendSizeChangeGTMData(this.state.selectedSize);

          // Set pricing
          const selectedItems = Object.values(this.dom.parentComponent.state.addToBagItems).filter(item => item.id && item.price);
          const bundleItems = this.getProduct().bundle_items;
          const items = [];
          if (selectedItems.length === bundleItems.length) {
            items.push(...selectedItems);

            const price = +this.getProduct().price;
            const comparePriceFromProduct = +this.getProduct().compare_at_price;
            const comparePriceFromItemsInBag = items.reduce((acc, item) => {
              return acc + +item.price;
            }, 0);
            const compareAtPrice = comparePriceFromItemsInBag || comparePriceFromProduct || 0;
            if (compareAtPrice > price) {
              document.querySelector('.js-compare-price').textContent = toMoney(compareAtPrice);
            } else {
              document.querySelector('.js-compare-price').classList.add('hidden');
              document.querySelector('.js-price').textContent = toMoney(compareAtPrice);
            }
          }
        });
      });
    }
    handleColorChange() {
      this.querySelectorAll(`.js-colors .js-input`).forEach((color) => {
        color.addEventListener('click', () => {
          this.state.selectedColor = color.value;
          this.setState();
          this.sendColorChangeGTMData(color.value);
        });
      });
    }
    async handleStyleChange() {
      const stylesDropdown = this.querySelector('.js-styles-dropdown');
      if (stylesDropdown) {
        stylesDropdown.addEventListener('change', async () => {
          const handle = stylesDropdown.value;
          if (handle) {
            let response = await fetch(`${window.Shopify.routes.root}products/${handle}?view=pdp-bundle-style`, {
              method: "get"
            });
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            response = await response.json();
            this.state.bundleItem = response;
            this.state.selectedStyleHandle = stylesDropdown.value;
            this.setState();
          }
        });
      }
    }
    setState(componentsToRender, expand = true) {
      const variant = this.getVariant();
      const detail = {
        activeBundleItem: this.state.bundleItem,
        activeBundleColor: this.state.selectedColor,
        addToBagItemId: this.props.itemNumber
      };
      let expandNext = false;
      if (variant && !this.isOutOfStock()) {
        const tags = this.getItemColor().tags;
        expandNext = true;
        detail.addToBagItem = {
          id: variant.id,
          price: variant.price,
          compare_at_price: variant.compare_at_price,
          sku: variant.sku,
          quantity: 1,
          properties: {
            ...this.dom.parentComponent.props.product.bundleProperties,
            _tags: filterProductTags(tags)
          }
        }

        // When compareAtPrice < price update bundle price (_bundlePrice and _price properties)
        const addToBagItems = this.dom.parentComponent.state.addToBagItems;
        addToBagItems[this.props.itemNumber] = detail.addToBagItem;
        const selectedItems = Object.values(addToBagItems).filter(item => item.id && item.price);
        const bundleItems = this.getProduct().bundle_items;
        if (this.props.comparePriceEnabled && selectedItems.length === bundleItems.length) {
          const price = +this.getProduct().price;
          const comparePriceFromProduct = +this.getProduct().compare_at_price;
          const comparePriceFromItemsInBag = selectedItems.reduce((acc, item) => {
            return acc + +item.price;
          }, 0);
          const compareAtPrice = comparePriceFromItemsInBag || comparePriceFromProduct || 0;
          if (compareAtPrice < price) {
            if (window.Shopify.country === 'CA' && compareAtPrice && compareAtPrice < price) {
              detail.addToBagItem.properties._bundlePrice = Math.trunc((compareAtPrice / 100) / window.i18n_cad_exchange_rate) * 100;
              detail.addToBagItem.properties._bundlePriceCa = compareAtPrice;
              detail.addToBagItem.properties._price = (compareAtPrice / 100).toString();
            } else if (compareAtPrice && compareAtPrice < price) {
              detail.addToBagItem.properties._bundlePrice = compareAtPrice;
              detail.addToBagItem.properties._bundlePriceCa = Math.ceil((compareAtPrice / 100) * window.i18n_cad_exchange_rate) * 100;
              detail.addToBagItem.properties._price = (compareAtPrice / 100).toString();
            }
          }
        }
      } else {
        detail.addToBagItem = {};
      }
      if (expand) {
        detail.expandedItemNumber = expandNext ? this.props.itemNumber + 1 : this.props.itemNumber;
      }
      if (componentsToRender) {
        detail.componentsToRender = componentsToRender;
      }
      this.dispatchEvent(new CustomEvent('set-state', {
        bubbles: true,
        detail
      }));
      if (this.state.bundleItem.colors[this.state.selectedColor]) {
        document.dispatchEvent(new CustomEvent('update-pdp-product-reviews', { detail: { handle: this.state.bundleItem.colors[this.state.selectedColor].handle } }));
      }
    }
    sendColorChangeGTMData(color) {
      window.sendGTMData && window.sendGTMData({
        event: 'pdp_item_color_select',
        product_id: this.getId(),
        color_selected: color,
        source: 'pdp-bundle'
      });
    }
  });
}

if (!customElements.get('component-pdp-bundle-add-to-bag')) {
  customElements.define('component-pdp-bundle-add-to-bag', class PDPBundleAddToBag extends PDPBundleSubComponent {
    constructor() {
      super();
      this.props.bundleNumber = parseInt(this.dataset.bundleNumber);
      this.props.sizeError = this.dataset.sizeError;
      this.props.selectAllError = this.dataset.selectAllError;
      this.props.bundleError = this.dataset.bundleError;
      this.props.cartError = this.dataset.cartError;
      this.render();
    }
    render() {
      const template = this.template.content.cloneNode(true);
      if (this.dom.parentComponent.state.showBundleError) {
        this.showError(template, this.props.bundleError);
        template.querySelector('.js-add-to-bag').remove();
      } else {
        this.updateAddToBagButtonText(template.querySelector('.js-add-to-bag'));
      }
      this.appendTemplate(template);
    }
    afterRender() {
      if (!this.dom.parentComponent.state.showBundleError) {
        document.addEventListener('clear-add-to-bag-error', () => {
          this.querySelector('.js-add-to-bag-error').classList.add('hidden');
        });
      }
      if (this.querySelector('.js-add-to-bag')) {
        this.updateAddToBagButtonText();
        this.querySelector('.js-add-to-bag').addEventListener('click', (event) => {
          event.preventDefault();
          // Validation
          if (this.showGlobalSize() && !this.dom.parentComponent.state.globalSize) {
            this.showError(this, this.props.sizeError);
            return;
          }
          if (this.dom.parentComponent.props.bundleNumber !== Object.keys(this.dom.parentComponent.state.addToBagItems).length) {
            document.dispatchEvent(new CustomEvent('add-to-bag-error'));
            return;
          }
          // Check if all items have a variant selected
          if (!Object.values(this.dom.parentComponent.state.addToBagItems).every(item => Object.keys(item).length !== 0)) {
            document.dispatchEvent(new CustomEvent('add-to-bag-error'));
            return;
          }
          this.addItemsToBag();
        });
      }
    }
    showError(template, error) {
      template.querySelector('.js-add-to-bag-error').innerHTML = error;
      template.querySelector('.js-add-to-bag-error').classList.remove('hidden');
    }
    hasCompleteBundleSelection() {
      if (this.dom.parentComponent.props.bundleNumber !== Object.keys(this.dom.parentComponent.state.addToBagItems).length) {
        return false;
      }
      return Object.values(this.dom.parentComponent.state.addToBagItems).every(item => item && Object.keys(item).length !== 0);
    }
    updateAddToBagButtonText(button = this.querySelector('.js-add-to-bag')) {
      if (!button) {
        return;
      }
      const text = this.hasCompleteBundleSelection() ? button.dataset.addToBagText : (button.dataset.selectSizeText || 'Select Size');
      button.innerHTML = text;
    }
    async addItemsToBag() {
      try {
        this.querySelector('.js-add-to-bag').innerHTML = this.querySelector('.js-add-to-bag').dataset.loadingText;
        this.querySelector('.js-add-to-bag').classList.add('add-to-bag-btn--loading');
        const payload = [];
        const bundleId = Object.values(this.dom.parentComponent.state.addToBagItems).map(item => item.id).join('/');
        const items = Object.values(this.dom.parentComponent.state.addToBagItems);
        let index = 0;

        const price = +this.getProduct().price;
        const comparePriceFromProduct = +this.getProduct().compare_at_price;
        const comparePriceFromItemsInBag = Object.values(this.dom.parentComponent.state.addToBagItems).reduce((acc, item) => {
          return acc + +item.price;
        }, 0);
        const compareAtPrice = comparePriceFromItemsInBag || comparePriceFromProduct || 0;

        for (const item of items) {
          item.properties['_bundleId'] = bundleId;
          item.properties['_index'] = index;
          if (index === 0) item.properties['_first'] = true;
          if (index === items.length - 1) item.properties['_last'] = true;
          item.properties['_tags'] = filterProductTags(this.getProduct().tags);

          if (window.Shopify.country === 'CA' && compareAtPrice && compareAtPrice > price) {
            item.properties._compareAtPrice = Math.trunc((compareAtPrice / 100) / window.i18n_cad_exchange_rate) * 100;
            item.properties._compareAtPriceCa = compareAtPrice;
          } else if (compareAtPrice && compareAtPrice > price) {
            item.properties._compareAtPrice = compareAtPrice;
            item.properties._compareAtPriceCa = Math.ceil((compareAtPrice / 100) * window.i18n_cad_exchange_rate) * 100;
          }

          if (window.Shopify.country === 'CA' && compareAtPrice && compareAtPrice < price) {
            item.properties._bundlePrice = Math.trunc((compareAtPrice / 100) / window.i18n_cad_exchange_rate) * 100;
            item.properties._bundlePriceCa = compareAtPrice;
            item.properties._price = (compareAtPrice / 100).toString();
          } else if (compareAtPrice && compareAtPrice < price) {
            item.properties._bundlePrice = compareAtPrice;
            item.properties._bundlePriceCa = Math.ceil((compareAtPrice / 100) * window.i18n_cad_exchange_rate) * 100;
            item.properties._price = (compareAtPrice / 100).toString();
          }

          index++;
          payload.push(item);
        }

        await window.cartManager.addItems(payload);

        if (compareAtPrice > price) {
          document.querySelector('.js-compare-price').innerHTML = toMoney(compareAtPrice);
        } else {
          document.querySelector('.js-compare-price').classList.add('hidden');
          document.querySelector('.js-price').textContent = toMoney(compareAtPrice);
        }

        window.dispatchEvent(new CustomEvent('update-cart'));

        // Clear error state if successful
        this.querySelector('.js-add-to-bag-error').classList.add('hidden');
      } catch (error) {
        console.error(error);
        this.showError(this, this.props.cartError);
      }
      // Clear add to bag loading state
      this.querySelector('.js-add-to-bag').classList.remove('add-to-bag-btn--loading');
      this.updateAddToBagButtonText();
    }
    getProduct() {
      return this.dom.parentComponent.props.product;
    }
  });
}

// Product details accordion subcomponent
if (!customElements.get('component-pdp-bundle-accordion')) {
  customElements.define('component-pdp-bundle-accordion', class PDPBundleAccordion extends HTMLElement {
    constructor() {
      super();
      this.state = {
        expanded: (window.innerWidth <= 1024 ? this.dataset.expandedMob : this.dataset.expanded) === "true"
      }
      this.props = {
        type: this.dataset.type
      }
      this.render();
    }
    render() {
      const template = this.querySelector('.js-template');
      const icon = document.createElement("span");
      if (this.state.expanded) {
        template.querySelector('.js-accordion-details').open = true;
      }
      icon.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.21967 9.21967C7.51256 8.92678 7.98744 8.92678 8.28033 9.21967L11.75 12.6893L15.2197 9.21967C15.5126 8.92678 15.9874 8.92678 16.2803 9.21967C16.5732 9.51256 16.5732 9.98744 16.2803 10.2803L12.2803 14.2803C12.1397 14.421 11.9489 14.5 11.75 14.5C11.5511 14.5 11.3603 14.421 11.2197 14.2803L7.21967 10.2803C6.92678 9.98744 6.92678 9.51256 7.21967 9.21967Z" fill="#2C272D"></path></svg>';
      template.querySelector('.js-accordion-icon').appendChild(icon);
      this.afterRender();
    }
    afterRender() {
      this.querySelector('.js-accordion-details').addEventListener('click', () => {
        this.state.expanded = !this.state.expanded;
      });
    }
  });
}

if (!customElements.get('component-pdp-bundle-models')) {
  customElements.define('component-pdp-bundle-models', class PDPBundleModels extends PDPBundleSubComponent {
    constructor() {
      super();
      this.state = {
        models: {},
        activeModel: '',
      }
      this.render();
    }
    render() {
      const template = this.template.content.cloneNode(true);
      // Reset state
      this.state.activeModel = '';
      this.state.models = {};
      this.state.models["All"] = [];
      // Add model ids from images alt tags
      if (this.getActiveColor()) {
        this.getActiveColor().images.map(image => {
          this.state.models["All"].push(image);
          const alt = image.alt.trim().split('model')[1];
          if (alt) {
            if (!this.state.models[alt]) {
              this.state.models[alt] = [];
            }
            this.state.models[alt].push(image);
          }
          return false;
        });
      }
      if (Object.keys(this.state.models).length > 1) {
        if (Object.keys(this.state.models).length > 2) {
          // Render 'All' model
          this.state.activeModel = 'All';
          this.renderModelBtn(template, "All", "All");
          template.querySelector('.js-models-mobile-swap-btn').classList.remove('hidden');
          template.querySelector('.js-container').classList.remove('desktop-hide-models');
        }
        for (const id in this.state.models) {
          if (id === 'All') {
            continue;
          }
          let size = this.getModelSize(id);
          if (this.state.activeModel === '' && size) {
            this.state.activeModel = size;
          }
          if (size) {
            this.renderModelBtn(template, size, id);
          }
        }
        setTimeout(() => {
          this.appendTemplate(template);
        }, 100);
      } else {
        this.dom.parentComponent.querySelector('.js-product-models-container').classList.add('product-models-container--no-models');
      }
    }
    renderModelBtn(template, size, id) {
      const modelTemplate = template.querySelector('.js-template-model').content.cloneNode(true);
      if (this.state.activeModel === size) {
        modelTemplate.querySelector('.js-model-btn').classList.add('active');
      }
      let imageSrc = this.state.models[id][0].src;
      if (size !== 'All' && this.state.models[id][1]) {
        imageSrc = this.state.models[id][1].src;
      }
      modelTemplate.querySelector('.js-model-img').src = imageSrc;
      modelTemplate.querySelector('.js-model-text').innerHTML = size;
      modelTemplate.querySelector('.js-model-btn').dataset.id = id;
      modelTemplate.querySelector('.js-model-btn').dataset.size = size;
      template.querySelector('.js-models').appendChild(modelTemplate);
    }
    afterRender() {
      this.querySelectorAll('.js-model-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          this.querySelectorAll('.js-model-btn').forEach(btn => btn.classList.remove('active'));
          btn.classList.add('active');
          this.querySelector('.js-models').classList.add('mobile-hide-models');
          this.querySelector('.js-mobile-models-divider').classList.remove('mobile-models-divider');
          document.dispatchEvent(new CustomEvent('update-images', {
            bubbles: true,
            detail: {
              images: this.state.models[btn.dataset.id]
            }
          }));
          this.state.activeModel = btn.dataset.size;
        });
      });
      // Mobile
      this.querySelector('.js-models-mobile-swap-btn').addEventListener('click', () => {
        this.querySelector('.js-models').classList.toggle('mobile-hide-models');
        this.querySelector('.js-mobile-models-divider').classList.toggle('mobile-models-divider');
        this.querySelector('.js-models-mobile-size').innerHTML = this.state.activeModel;
      });
      // Listen for event when mobile gallery image updates
      document.addEventListener('update-model-size', event => {
        if (event.detail && event.detail.modelSize) {
          this.state.activeModel = event.detail.modelSize;
        }
        if (this.querySelector('.js-models-mobile-size')) this.querySelector('.js-models-mobile-size').innerHTML = this.state.activeModel;
      });
    }
  });
}
